import React from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createStructuredSelector } from 'reselect';
import { BoxesContainer, Box, BoxesRow, ContactBox, InvoiceBox, ProductBox, OrdersBox } from './components';
import * as customer from '../../../modules/customer/profile';
import ActionButton from '../../components/ActionButton';

const ProfilePageBoxes = ({id, financialBalance, contactList, invoicesList, softwareProducts, hardwareProducts, contactsClickHandler, softwareProductsClickHandler,
    hardwareProductsClickHandler, invoicesClickHandler, isInvoiceBoxLoading, isContactBoxLoading, isLoadingShippingOrders,isLoadingWorkOrders, addHardwaresClickHandler}) => {
    
    const getUrl = (type) => `/#/customer/${id}/${type}`;

    const productButtons = [
        <ActionButton icon="list1" to={getUrl('products')} title="Liste" key={"abListe"}/>,
        <ActionButton icon="blocked" to={getUrl('productcancelation')} title="Kansellering" key={"abKansellering"}/>,
        <ActionButton icon="key" to={getUrl('serials')} title="Serienumre" key={"abSerienumre"}/>,
        <ActionButton icon="link" to={getUrl('hardwareproducts/addhardware')} title="Registrer utstyr" key={"abRegistrerutstyr"}/>,
        <ActionButton icon="plus" to={getUrl('order')} title="Legg til produkter" key={"abLeggtilprodukter"} />
    ];
    
    const orderButtons = [
        <ActionButton icon="truck" to={getUrl('shippingOrders')} title="Fraktordre" key={"abFraktordre"}/>,
        <ActionButton icon="wrench" to={getUrl('workOrders')} title="Work orders" key={"abWorkorders"} />,
    ];

    return (
        <div>
            <BoxesRow>
                <Box
                    id="prodAndSubscBox"
                    label="Utstyr og abonnement"
                    buttons={productButtons}
                    isLoading={softwareProducts.isLoading || hardwareProducts.isLoading}>
                    <ProductBox hardwareProducts={hardwareProducts} softwareProducts={softwareProducts} customerId={id} />
                </Box>
            </BoxesRow>
            <BoxesRow>
                {/*<Box
                    id="invoiceBox"
                    className="col-md-4"
                    label="Faktura"
                    clickHandler={invoicesClickHandler.bind(undefined, id)}
                    isLoading={isInvoiceBoxLoading}>
                    <InvoiceBox invoices={invoicesList} financialBalance={financialBalance} />
                </Box>*/}
                <Box
                    id="contractsBox"
                    className="col-md-4"
                    label="Henvendelse"
                    clickHandler={contactsClickHandler.bind(undefined, id)}
                    isLoading={isContactBoxLoading}>
                    <ContactBox rows={contactList} />
                </Box>
                <Box
                    id="ordersBox"
                    className="col-md-4 ordersBox"
                    label="Ordre"
                    buttons={orderButtons}
                    isLoading={isLoadingShippingOrders || isLoadingWorkOrders}>
                    <OrdersBox customerId={id} />
                </Box>
            </BoxesRow>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    id: customer.selectors.getCustomerID,
    contactList: customer.contacts.selectors.getNumberOfContacts(5),
    isContactBoxLoading: customer.contacts.selectors.isLoading,
    isLoadingShippingOrders: customer.shippingOrders.selectors.isLoading,
    isLoadingWorkOrders: customer.workOrders.selectors.isLoading,
    isInvoiceBoxLoading: customer.invoices.selectors.isLoading,
    invoicesList: customer.invoices.selectors.getNumberOfInvoices(2),
    softwareProducts: customer.softwareProducts.selectors.getSoftwareProducts,
    hardwareProducts: customer.hardwareProducts.selectors.getHardwareProducts,
    financialBalance: customer.invoices.selectors.getFinancialBalance
});

const mapDispatchToProps = dispatch => ({
    contactsClickHandler: (id) => dispatch(push(`/customer/${id}/contacts`)),
    softwareProductsClickHandler: (id) => dispatch(push(`/customer/${id}/products`)),
    hardwareProductsClickHandler: (id) => dispatch(push(`/customer/${id}/shippingOrders`)),
    invoicesClickHandler: (id) => dispatch(push(`/customer/${id}/invoices`)),
    addHardwaresClickHandler: (id) => dispatch(push(`/customer/${id}/hardware_products/add_hardware`))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePageBoxes);  
